import React, { useRef, useEffect, useState } from "react";
import anime from "animejs";
import { random, clone } from "lodash";
import { State } from "../core";
import { Robot } from "../Robot";
import { Group } from "three";
import {
  INDICATOR_SHRINK_DURATION,
  SHRINK_TRAVEL_DELAY,
  CENTER_TRAVEL_DURATION
} from "../constants";

interface ChoirProps {
  state: State;
  responsePlayCount: number;
}
export const Choir: React.FC<ChoirProps> = React.memo(
  ({ state, responsePlayCount }) => {
    let groupRef = useRef<Group>();
    let [playCounts, setPlayCounts] = useState([0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);

    useEffect(() => {
      setPlayCounts(pcs => {
        let newPcs = clone(pcs);
        if (responsePlayCount === 0) {
          for (let i = 0; i < newPcs.length; i++) {
            newPcs[i] = 0;
          }
        } else {
          let idx = random(0, newPcs.length);
          newPcs[idx] = newPcs[idx] + 1;
        }
        return newPcs;
      });
    }, [responsePlayCount]);

    useEffect(() => {
      let animation: anime.AnimeInstance;
      if (state.state === "sending" || state.state === "sent") {
        animation = anime({
          targets: (groupRef.current as Group).position,
          y: 5,
          duration: CENTER_TRAVEL_DURATION,
          delay: INDICATOR_SHRINK_DURATION + SHRINK_TRAVEL_DELAY,
          easing: "easeInOutCubic"
        });
      } else {
        if (state.state === "start") {
          (groupRef.current as Group).position.y = 20;
        } else {
          animation = anime({
            targets: (groupRef.current as Group).position,
            y: 20,
            duration: CENTER_TRAVEL_DURATION,
            easing: "easeInOutCubic"
          });
        }
      }
      return () => {
        animation && animation.pause();
      };
    }, [state]);

    return (
      <group ref={groupRef}>
        <Robot x={-2} y={1.5} rotation={1} playCount={playCounts[0]} />
        <Robot x={-1.25} y={1.25} rotation={1} playCount={playCounts[1]} />
        <Robot x={-1.25} y={2.4} rotation={0.5} playCount={playCounts[2]} />
        <Robot x={-0.5} y={1.75} rotation={0.5} playCount={playCounts[3]} />
        <Robot x={-0.4} y={3} rotation={0.15} playCount={playCounts[4]} />
        <Robot x={0.4} y={3} rotation={-0.15} playCount={playCounts[5]} />
        <Robot x={0.5} y={1.75} rotation={-0.5} playCount={playCounts[6]} />
        <Robot x={1.25} y={2.4} rotation={-0.5} playCount={playCounts[7]} />
        <Robot x={1.25} y={1.25} rotation={-1} playCount={playCounts[8]} />
        <Robot x={2} y={1.5} rotation={-1} playCount={playCounts[9]} />
      </group>
    );
  }
);
